module.exports = __webpack_public_path__ + "static/media/main-video-thumbnail.16f1a37b.jpg";